module.exports = __webpack_public_path__ + "static/media/next-arrow.673bf86c.svg";